import { FC } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

export const FullLayout: FC = () => {
	const { setIsTableOfContents } = useOutletContext<{ setIsTableOfContents: (isSetTableOfContents: boolean) => void }>();

	return <Outlet context={{ setIsTableOfContents }} />;
};
